import { MUIBox, tokens, MUITypography } from "@cobee/cobee-ui";
import { translate } from "infrastructure/translate/localization";

export default function TitleDescription({
  title,
  description,
}: {
  title: string;
  description: string;
}) {
  return (
    <MUIBox>
      <MUITypography
        variant="h6"
        color={tokens.palette.grey[900]}
        sx={{
          fontSize: "16px !important",
        }}
      >
        {translate(title)}
      </MUITypography>
      <MUITypography color={tokens.palette.grey[700]} variant="body2" py={1}>
        {translate(description)}
      </MUITypography>
    </MUIBox>
  );
}
